//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'tax-info',
  components: {},
  props: {
    staffInfo: {
      type: Object,
      default: function _default() {}
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      calculationRule: {
        // 个人所得税
        3: [{
          text: this.$t('basic_info_7'),
          // 个人所得税_新法
          value: '3'
        }, {
          text: this.$t('basic_info_8'),
          // 固定税率
          value: '2'
        }],
        // 预扣税
        4: [{
          text: this.$t('basic_info_4'),
          // 员工缴纳
          value: '41'
        }, {
          text: this.$t('basic_info_5'),
          // 公司缴纳
          value: '42'
        }, {
          text: this.$t('basic_info_6'),
          // 公司缴纳-一次
          value: '43'
        }]
      }
    };
  },
  mounted: function mounted() {},
  methods: {}
};